<template>
  <div class="content-wrapper">
    <Loader v-if="!notificationLoaded" />
    <div v-if="notificationLoaded">
      <div v-for="(notification, index) in notificationList" v-bind:key="index">
        <h3>{{ notification.date }}</h3>
        <h2>{{ notification.subject }}</h2>
        <p v-html="decodeDescription(notification.description)"></p>
        <hr>
      </div>
      <h2 v-if="!notificationList.length">{{ $t("notification.notificationHome.errorMsg") }}</h2>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue'

import { userService } from '@/services/user.service'

export default {
  name: 'NotificationHome',
  components: {
    Loader
  },
  data: function () {
    return {
      notificationList: [],
      notificationLoaded: false
    }
  },
  created: function () {
    this.fetchNotification()
  },
  methods: {
    fetchNotification: function () {
      userService.getNotification().then(notificationList => {
        this.notificationList = notificationList
        this.notificationLoaded = true
      }).catch((err) => {
        console.error('Unable to get notification: ', err)
      })
    },
    decodeDescription: function(description){
      return decodeURIComponent(atob(description))
    }
  }
}
</script>
